import { StripeACH } from "@/api/opb/opbTypes";
import {
  CardLogo,
  Tag,
  TagVariant,
  TextButton,
} from "@industriousoffice/react-components";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

interface StripeACHInfoProps {
  paymentMethod: StripeACH;
  withEdit?: boolean;
  footer?: ReactNode;
}

export function StripeACHInfo({
  paymentMethod,
  withEdit,
  footer,
}: StripeACHInfoProps) {
  const { t } = useTranslation("paymentMethods");

  return (
    <>
      <div className="pt-1 grow-0">
        <CardLogo cardType="ACH" />
      </div>
      <div className="relative flex-wrap w-24 pl-3 text-left grow shrink-0">
        <div className="flex items-center">
          <div className="capitalize">{paymentMethod.bankAccountType}</div>
          {paymentMethod.default && (
            <Tag
              text={t("Default")}
              variant={TagVariant.Info}
              className="h-5 mx-2 font-normal rounded-sm"
            />
          )}
        </div>
        <div>
          <span className="font-bold">{paymentMethod.bankName}</span>
          {paymentMethod.bankAccountNumber}
        </div>
        {withEdit ? (
          <TextButton
            type="button"
            className="absolute top-1 right-3"
            testId={`ach-edit_${paymentMethod.id}-btn`}
          >
            {t("Edit")}
          </TextButton>
        ) : null}
        {footer}
      </div>
    </>
  );
}
